import { render, staticRenderFns } from "./HeaderLogged.vue?vue&type=template&id=cb65675e&scoped=true"
import script from "./HeaderLogged.vue?vue&type=script&lang=js"
export * from "./HeaderLogged.vue?vue&type=script&lang=js"
import style0 from "./HeaderLogged.vue?vue&type=style&index=0&id=cb65675e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb65675e",
  null
  
)

export default component.exports